import api from '../../../services/api';

export const BossHTTP = {
  get: (params = {}) => api.get('/boss', {params}),
  getById: (id = '') => api.get(`/boss/${id}`),
  create: (payload = {}) => api.post('/boss', payload),
  update: (id = '', payload = {}) => api.put(`/boss/${id}`, payload),
};
